import * as u from "react";
function o(i, m) {
  var a, e, t;
  return /* @__PURE__ */ u.isValidElement(i) && m.indexOf(
    // For server components `muiName` is avaialble in element.type._payload.value.muiName
    // relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    i.type.muiName ?? ((t = (e = (a = i.type) == null ? void 0 : a._payload) == null ? void 0 : e.value) == null ? void 0 : t.muiName)
  ) !== -1;
}
export {
  o as i
};
//# sourceMappingURL=isMuiElement-DnSE4qG4.mjs.map
